import { InvoiceActionCreators } from 'actions/invoice';
import { appendInvoiceAtFirstInInvoicePage, appendInvoicePage, initialState, removeInvoiceFromInvoicePage,  updateInvoiceFromInvoicePage } from 'helper/invoice';

type Action = typeof InvoiceActionCreators[keyof typeof InvoiceActionCreators];

export function invoiceReducer(state = initialState, action: Action): typeof initialState {
  switch (action.type) {
    case InvoiceActionCreators.showInvoicePage.type:
      return { ...state, invoicePage: { ...action.payload } };
    case InvoiceActionCreators.appendInvoicePage.type:
      return { ...state, invoicePage: { ...appendInvoicePage(action.payload, state.invoicePage) } };
    case InvoiceActionCreators.updateErrorType.type:
      return { ...state, errorType: action.payload };
    case InvoiceActionCreators.createInvoice.type:
      return { ...state, invoice: action.payload, invoicePage: { ...appendInvoiceAtFirstInInvoicePage(action.payload, state.invoicePage) } };
    case InvoiceActionCreators.updateInvoice.type:
      return { ...state, invoice: action.payload, invoicePage: { ...updateInvoiceFromInvoicePage(action.payload, state.invoicePage) } };
    case InvoiceActionCreators.removeInvoice.type:
      return { ...state, invoicePage: { ...removeInvoiceFromInvoicePage(action.payload, state.invoicePage) } };
    case InvoiceActionCreators.setIsOnRequest.type:
      return { ...state, isLoading: true };
    case InvoiceActionCreators.setIsReceived.type:
      return { ...state, isLoading: false };
    case InvoiceActionCreators.setIsInvoicePageUpdated.type:
      return { ...state, isInvoicePageUpdated: true };
    case InvoiceActionCreators.setHasNotPassedOnboarding.type:
      return { ...state, hasPassedOnboarding: false };
    case InvoiceActionCreators.setHasPassedOnboarding.type:
      return { ...state, hasPassedOnboarding: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/invoice.ts